<template>
    <div class="feature-edit" v-loading="loading">
        <transition name="fade" mode="out-in">
            <div v-if="addMode" key="addMode">
                <div class="row">
                    <div class="col-md-12">
                        <el-form :model="formAdd" :rules="formAddRules" ref="formAdd" label-width="200px">
                            <el-form-item label="ShopID" prop="shop_id">
                                <el-input v-model="formAdd.shop_id"></el-input>
                            </el-form-item>
                            <el-form-item label="Valeur" prop="value">
                                <el-input v-model="formAdd.value"></el-input>
                            </el-form-item>
                            <div class="pull-right">
                                <button @click.prevent="cancelAdd" class="btn btn-outline-secondary">Annuler</button>
                                <button @click.prevent="saveAdd" class="btn btn-outline-primary">Ajouter</button>
                            </div>
                            <div class="clearfix"></div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div v-else key="listMode">
                <el-form v-if="feature" :model="feature" :rules="formEditRules" ref="formEdit" label-width="200px">
                    <el-form-item label="ShopID" prop="shop_id">
                        <el-input v-model="feature.shop_id"></el-input>
                    </el-form-item>
                    <el-form-item label="Nom" prop="name">
                        <el-input v-model="feature.name"></el-input>
                    </el-form-item>
                    <el-form-item prop='display_priority' label="Priorité d'affichage">
                        <el-input type='number' step='1' v-model="feature.display_priority"></el-input>
                        <p class='form-text text-muted'>Une priorité 3 sera affichée avant une priorité 20.</p>
                    </el-form-item>
                    <el-form-item prop='all_products'>
                        <el-switch
                            v-model="formAdd.all_products"
                            active-value="1"
                            inactive-value="0"
                            active-text="Ajouter à tous les types de produits"
                        ></el-switch>
                    </el-form-item>

                    <el-form-item prop='zero_products'>
                        <el-switch
                            v-model="formAdd.remove_products"
                            active-value="1"
                            inactive-value="0"
                            active-text="Supprimer de tous les types de produits"
                        >
                            Ajouter à tous les types de produits
                        </el-switch>
                    </el-form-item>


                    <div class="pull-right">
                        <button @click.prevent="saveEdit" class="btn btn-outline-primary">Enregistrer</button>
                    </div>
                    <div class="clearfix"></div>
                </el-form>
                <hr>
                <div class="pull-left" v-if="hasSelection">
                    <button @click.prevent="removeAll" class="btn btn-outline-danger">Supprimer</button>
                </div>
                <div class="pull-right">
                    <button v-if="hasEditMode" @click.prevent="cancelEditMode" class="btn btn-outline-secondary ">Annuler l'edition</button>
                    <button v-if="hasEditMode" @click.prevent="saveAll" class="btn btn-outline-success ">Sauvegarder</button>
                    <button v-if="feature && feature.id" @click.prevent="add" class="btn btn-outline-primary">Ajouter une valeur</button>
                </div>
                <div class="clearfix"></div>
                <el-table class="table-values" v-if="feature && feature.id" @selection-change="handleSelectionChange" @row-dblclick="(row, event)=> edit(row)" style="width: 100%" :data="values" stripe>
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="ID Speedway">
                        <template slot-scope="scope">
                            <template v-if="!scope.row.editMode">
                                {{ scope.row.shop_id }}
                            </template>
                            <template v-if="scope.row.editMode">
                                <el-input placeholder="ShopID" v-model="scope.row.datasEditInline.shop_id"></el-input>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="Valeur">
                        <template slot-scope="scope">
                            <template v-if="!scope.row.editMode">
                                {{ scope.row.value }}
                            </template>
                            <template v-if="scope.row.editMode">
                                <el-input placeholder="Prix" v-model="scope.row.datasEditInline.value"></el-input>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="Actions" >
                        <template slot-scope="scope">
                            <template v-if="!scope.row.inlineLoader">
                                <a v-if="!scope.row.editMode" href="#" @click.prevent="edit(scope.row)" title='Editer'><i class="fe fe-edit"></i></a>
                                <a v-if="scope.row.editMode" href="#" @click.prevent="save(scope.row)" title='Sauvegarder'><i class="fe fe-save"></i></a>
                                <a v-if="feature.name === 'Type de produit'" href="#" @click.prevent="openFeaturesList(scope.row)" title='Gestion des features affichées'><i class="fe fe-list"></i></a>
                                <a v-if="feature.name === 'Type de produit'" href="#" @click.prevent="openTitleDescription(scope.row)" title='Gestion des titres de description détaillée'><i class="fe fe-type"></i></a>
                                <a v-if="!scope.row.editMode" href="#" class="text-danger" @click.prevent="remove(scope.row)" title='Supprimer'><i class="fe fe-trash-2"></i></a>
                            </template>
                            <template v-if="scope.row.inlineLoader">
                                <i class="el-icon-loading"></i>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog title="Choix des features disponible" :modal="false" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="modalChoiceFeature.visible" width="85%" >
                    <el-transfer class="choiceFeatures mb-5" :filterable='true' :props="{key: 'id', label: 'name'}" :titles="['Liste des features', 'Features autorisées']" v-model="modalChoiceFeature.form.features_list" :data="allFeatures"></el-transfer>

                    <h4>Features obligatoires</h4>
                    <label
                        class='mb-2 mr-2'
                        v-for='(feature, index) in allFeatures.filter((v) => modalChoiceFeature.form.features_list.includes(v.id))'>
                        <input type='checkbox' v-model='modalChoiceFeature.form.required_features_list' :value='feature.id'> {{ feature.name }}
                    </label>


                    <span slot="footer" class="dialog-footer">
                        <el-button @click="modalChoiceFeature.visible = false">Annuler</el-button>
                        <el-button type="primary" @click="save(modalChoiceFeature.featureValue, 'features_list')">Sauvegarder</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Choix des titres" :modal="false" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="modalTitleDescription.visible" width="80%" >
                    <el-input placeholder="titre" v-model="modalTitleDescription.form.to_add">
                        <template slot="append">
                            <el-button @click="addTitle" type="primary" icon="el-icon-plus"></el-button>
                        </template>
                    </el-input>
                    <el-input class="mt-2" placeholder="Aide" v-model="modalTitleDescription.form.to_add_help"></el-input>

                    <draggable v-model="modalTitleDescription.form.title_description">
                        <div class="mt-2 item-title" :key="index" v-for="(title, index) in modalTitleDescription.form.title_description">
                            <el-input placeholder="titre" v-model="modalTitleDescription.form.title_description[index].value">
                                <template slot="prepend">
                                    <el-button type="primary" >
                                        <svg xmlns="http://www.w3.org/2000/svg" style="width:1.5em;height:1.5em;" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                                        </svg>
                                    </el-button>
                                </template>
                                <template slot="append">
                                    <el-button @click="removeTitle(index)" type="primary" icon="el-icon-minus"></el-button>
                                </template>
                            </el-input>
                            <el-input class="mt-2" placeholder="Aide" v-model="modalTitleDescription.form.title_description[index].help"></el-input>
                        </div>
                    </draggable>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="modalTitleDescription.visible = false">Annuler</el-button>
                        <el-button type="primary" @click="save(modalTitleDescription.featureValue, 'title_description')">Sauvegarder</el-button>
                    </span>
                </el-dialog>
            </div>
        </transition>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
import FeatureValue from '../../models/FeatureValue';
import Feature from '../../models/Feature';
import { EventBus } from '../../event-bus';
export default {
    components: {
        draggable,
    },
    data() {
        return {
            loading: false,
            values: [],
            formAdd: {
                value: null,
                shop_id: null,
                all_products: false,
                remove_products: false,
            },
            allFeatures: [],
            modalChoiceFeature: {
                visible: false,
                featureValue: null,
                form: {
                    features_list: []
                }
            },
            modalTitleDescription: {
                visible: false,
                featureValue: null,
                form: {
                    to_add: null,
                    to_add_help: null,
                    title_description: []
                }
            },
            formAddRules: {
                value: [
                    {
                        required: true,
                        message: 'Le champs est obligatoire',
                        trigger: 'change'
                    }
                ],
                shop_id: [
                    {
                        required: true,
                        message: 'Le champs est obligatoire',
                        trigger: 'change'
                    }
                ]
            },
            formEditRules: {
                name: [
                    {
                        required: true,
                        message: 'Le champs est obligatoire',
                        trigger: 'change'
                    }
                ],
                shop_id: [
                    {
                        required: true,
                        message: 'Le champs est obligatoire',
                        trigger: 'change'
                    }
                ]
            },
            feature: null,
            addMode: false,
            multipleSelection: []
        };
    },
    props: {
        featureId: {
            required: true
        }
    },
    computed: {
        hasEditMode() {
            return this.values.filter(v => v.editMode).length;
        },
        hasSelection() {
            return this.multipleSelection.length;
        }
    },
    watch: {
        featureId() {
            this.refresh()
        }
    },
    mounted() {
        this.refresh();
        EventBus.$on('modal.feature-edit.closed', () => {});
    },
    methods: {
        addTitle()
        {
            let value = this.modalTitleDescription.form.to_add;
            if( !value ){
                return
            }
            value = value.trim();
            if( !value ) {
                return
            }
            this.modalTitleDescription.form.title_description.push({
                value,
                help: this.modalTitleDescription.form.to_add_help
            });
            this.modalTitleDescription.form.to_add = null;
            this.modalTitleDescription.form.to_add_help = null;
        },
        removeTitle(index)
        {
            this.modalTitleDescription.form.title_description.splice(index, 1)
        },
        openTitleDescription(featureValue)
        {
            this.modalTitleDescription.featureValue = null;
            this.modalTitleDescription.featureValue = featureValue;
            var current = [...featureValue.title_description || []];
            this.modalTitleDescription.form.title_description = current
            this.modalTitleDescription.visible = true;
        },
        openFeaturesList(featureValue)
        {
            this.modalChoiceFeature.form.features_list = [];
            this.modalChoiceFeature.form.required_features_list = [];
            this.modalChoiceFeature.featureValue = null;
            this.modalChoiceFeature.featureValue = featureValue;
            this.modalChoiceFeature.form.features_list = this.modalChoiceFeature.form.features_list.concat(featureValue.features_list)
            this.modalChoiceFeature.form.required_features_list = this.modalChoiceFeature.form.required_features_list.concat(featureValue.required_features_list ?? [])
            this.modalChoiceFeature.visible = true;
        },
        reset() {
            this.addMode = false;
            this.cancelEditMode();
        },
        refresh() {
            this.loading = true;
            this.addMode = false;
            if( !this.featureId ) {
                this.loading = false;
                this.feature = new Feature;
            } else {
                this.fetch().then(() => {
                    this.loading = false;
                });
            }
        },
        fetch() {
            return axios
                .get('/features/' + this.featureId)
                .then(r => {
                    this.feature = Feature.create(r.data.data);
                    this.values = FeatureValue.build(r.data.data.values);
                    this.allFeatures = this.toAlphaOrder(r.data.allFeatures);
                });
        },
        add() {
            this.cancelEditMode();
            this.addMode = true;
            this.formAdd = {
                value: null,
                shop_id: null,
            };
        },
        saveAdd() {
            this.$refs.formAdd.validate(valid => {
                if (valid) {
                    this.loader = true;
                    axios
                        .post(
                            '/features/' + this.feature.id + '/values',
                            this.formAdd
                        )
                        .then(r => {
                            let featureValue = FeatureValue.create(r.data.data);
                            this.values.push(featureValue);
                            this.cancelAdd();
                        })
                        .catch(() => {})
                        .then(() => {
                            this.loader = false;
                        });
                }
            });
        },
        cancelAdd() {
            this.addMode = false;
        },
        cancelEditMode() {
            this.values.forEach(v => v.cancelEditMode());
        },
        edit(featureValue) {
            featureValue.setEditMode();
        },
        saveAll() {
            var values = this.values.filter(v => v.editMode);
            values.forEach(v => this.save(v));
        },
        saveEdit() {
            if( this.feature && this.feature.id ) {
                axios
                    .put(
                        '/features/' +
                            this.feature.id,
                        {
                            name: this.feature.name,
                            shop_id: this.feature.shop_id,
                            all_products: this.formAdd.all_products,
                            remove_products: this.formAdd.remove_products,
                            display_priority: this.feature.display_priority,
                        }
                    )
                    .then(r => {
                        this.$message({
                            message: 'Feature modifier',
                            type: 'success'
                        });
                        this.resetForm();
                    })
                    .catch(() => {})
                    .then(() => {

                    });
            } else {
                axios
                    .post(
                        '/features',
                        {
                            name: this.feature.name,
                            shop_id: this.feature.shop_id,
                            all_products: this.formAdd.all_products,
                            remove_products: this.formAdd.remove_products,
                            display_priority: this.feature.display_priority,
                        }
                    )
                    .then(r => {
                        this.$message({
                            message: 'Feature ajouter.',
                            type: 'success'
                        });
                        this.feature = Feature.create(r.data.data);
                        this.values = FeatureValue.build(r.data.data.values);
                        this.resetForm();
                    })
                    .catch(() => {})
                    .then(() => {

                    });
            }

        },
        resetForm() {
            this.formAdd = {
                name: null,
                shop_id: null,
                all_products: false,
                remove_products: false,
            };
        },
        save(featureValue, mode = 'update') {
            if( mode == 'update' ) {
                var datas = featureValue.saveEditMode();
                featureValue.inlineLoader = true;
            } else if ( mode == 'features_list' ) {
                var datas = this.modalChoiceFeature.form
            } else if ( mode == 'title_description' ) {
                var datas = this.modalTitleDescription.form
            }
            axios
                .post(
                    '/features/' +
                        this.feature.id +
                        '/values/' +
                        featureValue.id,
                    {
                        ...datas,
                        mode: mode
                    }
                )
                .then(r => {
                    featureValue.update(r.data.data);
                })
                .catch(() => {})
                .then(() => {
                    if( mode == 'update' ) {
                        featureValue.inlineLoader = false;
                    } else if ( mode == 'features_list' ) {
                        this.modalChoiceFeature.visible = false;
                    } else if ( mode == 'title_description' ) {
                        this.modalTitleDescription.visible = false;
                    }
                });
        },
        remove(featureValue) {
            this.$confirm('Voulez-vous supprimer la valeur', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    featureValue.inlineLoader = true;
                    axios
                        .delete(
                            '/features/' +
                                this.feature.id +
                                '/values/' +
                                featureValue.id
                        )
                        .then(r => {
                            this.removeToList(featureValue);
                        })
                        .catch(() => {})
                        .then(() => {
                            featureValue.inlineLoader = false;
                        });
                })
                .catch(() => {});
        },
        removeAll() {
            this.$confirm('Voulez-vous supprimer les valeurs', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    this.multipleSelection.forEach(featureValue => {
                        featureValue.inlineLoader = true;
                        axios
                            .delete(
                                '/features/' +
                                    this.feature.id +
                                    '/values/' +
                                    featureValue.id
                            )
                            .then(r => {
                                this.removeToList(featureValue);
                            })
                            .catch(() => {})
                            .then(() => {
                                featureValue.inlineLoader = false;
                            });
                    });
                })
                .catch(() => {});
        },
        removeToList(featureValue) {
            var index = this.values.findIndex(v => v.id == featureValue.id);
            if (index != -1) {
                this.values.splice(index, 1);
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        toAlphaOrder(values) {
            return values.sort((a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
        },

    }
};
</script>
<style lang="scss">
.feature-edit {
    .silent-link {
        &:hover {
            text-decoration: none;
        }
    }
    .placeholder-img {
        text-align: center;
        width: 120px;
        height: 90px;
        background: #e7e7e7;
        vertical-align: middle;
        display: table-cell;
        color: #007bfffc;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .table-values {
        height: 51vh;
        overflow: auto;
    }
    .choiceFeatures {
        height: 50vh;
    }
    .el-transfer-panel {
        width: 37%;
        height: 100%;
        .el-transfer__buttons {
            width: 25%;
        }
        .el-transfer-panel__body {
            height: 90%;
        }
        .el-transfer-panel__list
        {
            height: 100%;
        }
    }
}
</style>
